import React, { FC, useEffect, useState } from 'react';
import { SiteInfoSelectsProps } from './SiteInfoSelectsProps';

import useTranslation from '../../../../hooks/useTranslation';
import CustomSelect from '../../../../common/CustomSelect';
import { getOptionsFromTranslation } from '../../../../utils/utils';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { getUnitsByCategory, isUnitTypeLada } from './utils';

const SiteInfoSelects: FC<SiteInfoSelectsProps> = ({
  unitType,
  transactionType,
  siteType,
  newUnitType,
  unitCategoryDisabled,
}) => {
  const t = useTranslation();
  const { setValue, watch } = useFormContext();
  const [unitOptions, setUnitOptions] = useState({});
  const category = watch('unitCategory');
  const unitTypeWatch = watch('unitType');

  useEffect(() => {
    if (category) {
      const options = getUnitsByCategory(category, t('unitTypes'));
      setUnitOptions(options);
    }
  }, [category]);

  useEffect(() => {
    if (isUnitTypeLada(unitTypeWatch)) {
      setValue('programmeName', 'lada');
    }
  }, [unitTypeWatch]);

  return (
    <>
      {unitType && (
        <>
          <CustomSelect
            optionsArray={getOptionsFromTranslation(t, 'unitCategories')}
            label={'Unit Category'}
            dataTestID={'unit-category-select'}
            name={'unitCategory'}
            customOnChange={() => {
              setValue('unitType', '');
            }}
            required
            disabled={unitCategoryDisabled}
            disableOnAll={false}
          />
          <Stack direction={'row'} spacing={2}>
            <CustomSelect
              optionsArray={unitOptions}
              name={'unitType'}
              required
              additionalStyle={!newUnitType ? { flex: '1' } : {}}
              label={t('projects.properties.unitType')}
              dataTestID={'unit-type-select'}
              disableOnAll={false}
            />
            {newUnitType && (
              <CustomSelect
                optionsArray={unitOptions}
                name={'newUnitType'}
                required
                label={t('projects.properties.newUnitType')}
                dataTestID={'new-unit-type-select'}
                disableOnAll={false}
              />
            )}
          </Stack>
        </>
      )}
      {siteType && (
        <CustomSelect
          optionsArray={getOptionsFromTranslation(t, 'siteTypes')}
          name={'siteType'}
          label={t('labels.siteType')}
          dataTestID={'site-type-select'}
        />
      )}
      {transactionType && (
        <CustomSelect
          optionsArray={getOptionsFromTranslation(t, 'transactionTypes')}
          name={'transactionType'}
          required
          label={t('ppm.columns.transactionType')}
          dataTestID={'transaction-type-select'}
        />
      )}
    </>
  );
};

export default SiteInfoSelects;
